import { Form } from 'antd'
import { FormInstance } from 'antd/lib/form/Form'
import { t } from 'i18next'
import { memo } from 'react'
import { useSelector } from 'react-redux'
import { SelectSource } from '../../../../components'
import { selectSourcePrivacyTypes } from '../../../../components/SelectSource'
import { DataSource } from '../../../../store/reducers/dataSourceReducer'

interface CreateWorkspaceModalResourcesStepProps {
  form: FormInstance
}

const CreateWorkspaceModalResourcesStep = memo(
  ({ form }: CreateWorkspaceModalResourcesStepProps) => {
    const currentUser = useSelector((state: any) => state.user.currentUser)
    const currentValue = form.getFieldValue('selectedDataSource')

    const handleOnChange = (value: DataSource | undefined) => {
      form.setFieldValue('selectedDataSource', value)
      form.setFieldValue('participants', currentUser ? [currentUser.id] : [])
    }

    return (
      <>
        <Form.Item
          name="selectedDataSource"
          label={t('createWorkspaceModal.resourcesStep.subHeader')}
          extra={t('createWorkspaceModal.resourcesStep.infoBox')}
          rules={[
            {
              required: true,
              message: t('errorMessage.isRequired') || '',
            },
          ]}
        >
          <SelectSource
            onChange={handleOnChange}
            value={currentValue?.id}
            privacy={selectSourcePrivacyTypes.INTERNAL}
            includeTypeCode={false}
            includeSearchable={false}
          />
        </Form.Item>
      </>
    )
  }
)

export default CreateWorkspaceModalResourcesStep
